var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapDouble(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_3649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.773 13.0229L15 17.7959L10.227 13.0229C9.28301 12.0789 8.64014 10.8762 8.3797 9.56683C8.11925 8.25746 8.25293 6.90026 8.76382 5.66687C9.27472 4.43347 10.1399 3.37927 11.2499 2.63757C12.3599 1.89588 13.665 1.5 15 1.5C16.335 1.5 17.6401 1.89588 18.7501 2.63757C19.8601 3.37927 20.7253 4.43347 21.2362 5.66687C21.7471 6.90026 21.8808 8.25746 21.6203 9.56683C21.3599 10.8762 20.717 12.0789 19.773 13.0229V13.0229ZM15 9.74994C15.3978 9.74994 15.7794 9.59191 16.0607 9.3106C16.342 9.0293 16.5 8.64777 16.5 8.24994C16.5 7.85212 16.342 7.47059 16.0607 7.18928C15.7794 6.90798 15.3978 6.74994 15 6.74994C14.6022 6.74994 14.2206 6.90798 13.9393 7.18928C13.658 7.47059 13.5 7.85212 13.5 8.24994C13.5 8.64777 13.658 9.0293 13.9393 9.3106C14.2206 9.59191 14.6022 9.74994 15 9.74994Z",
    fill: "#686868"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_235_3649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64645 20.1495L9 20.503L9.35356 20.1495L14.1266 15.3765L13.773 15.0229L14.1266 15.3765C15.1405 14.3626 15.831 13.0707 16.1107 11.6644C16.3904 10.258 16.2469 8.80028 15.6981 7.47552C15.1494 6.15076 14.2201 5.01848 13.0279 4.22184C11.8356 3.4252 10.4339 3 9 3C7.56609 3 6.16438 3.4252 4.97213 4.22184C3.77987 5.01848 2.85062 6.15076 2.30188 7.47552C1.75315 8.80028 1.60957 10.258 1.8893 11.6644C2.16904 13.0707 2.85953 14.3626 3.87345 15.3765L4.227 15.0229L3.87345 15.3765L8.64645 20.1495ZM9.70711 10.957C9.51957 11.1446 9.26522 11.2499 9 11.2499C8.73479 11.2499 8.48043 11.1446 8.2929 10.957C8.10536 10.7695 8 10.5152 8 10.2499C8 9.98472 8.10536 9.73037 8.2929 9.54283C8.48043 9.3553 8.73479 9.24994 9 9.24994C9.26522 9.24994 9.51957 9.3553 9.70711 9.54283C9.89465 9.73037 10 9.98472 10 10.2499C10 10.5152 9.89465 10.7695 9.70711 10.957Z",
    fill: "#686868",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_3649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_235_3649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapDouble);
export default __webpack_public_path__ + "static/media/icon_map_double.0403ef6a4c74a911d115be928c840adf.svg";
export { ForwardRef as ReactComponent };